import React, { memo, useMemo } from 'react'

import { Block, CRRender, Image, Inline } from '@comp/crRender'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'
import { SetLocStorage, toolTipAtrributes } from '@/utils'
import { Icon } from '@iconify/react/dist/iconify.js';
import "./style.css"
import { GetHeaderData } from './AuthContentConst'
const Navbar = () => {

    const { t } = useTranslation()
    const { pathname } = useLocation()
    const { img, caption, title } = useMemo(() => GetHeaderData(), [pathname])
    const { i18n } = useTranslation()
    const handleChangeLanguage = () => {
        var newLanguage = i18n.language === "ar" ? "en" : "ar";
        i18n.changeLanguage(newLanguage);
        SetLocStorage('i18nextLng', newLanguage)
    }
    const isNeedRender = useMemo(() => Boolean(img) || Boolean(caption) || Boolean(title), [img, caption, title])

    return (
        <CRRender isRender={isNeedRender}>
            <Image src={img} isRender={img} className={"form-logo"} />
            <CRRender isRender={caption || title}>
                <Inline isRender={caption} className={"caption"}> {t(caption)}</Inline>
                <div className='caption-container'>
                <Block isRender={title} className={"login-title "}> {t(title)}</Block>
                    <div {...toolTipAtrributes("change-language")} className='language-selector' onClick={() => handleChangeLanguage()}>
                        <Icon icon={"bi:translate"} />
                    </div>
                </div>
            </CRRender>

        </CRRender >

    )
}

export default memo(Navbar)